var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#666666;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star",
    className: "st0",
    d: "M8.998,1.1601c0.0294,0.0635,0.0635,0.1437,0.1019,0.2445l1.7949,4.5044l0.014,0.0351l0.0166,0.034  C11.2431,6.6275,11.835,7,12.5495,7h4.0098l-3.302,3.0919c-0.4486,0.4416-0.6533,1.0767-0.5474,1.6987l0.0165,0.0967l0.035,0.0917  l1.7431,4.5702l0.0627,0.1807c0.0292,0.0836,0.0626,0.1792,0.0868,0.2484c-0.0246-0.0154-0.0592-0.0392-0.1057-0.0758  l-4.5264-3.3559c-0.3003-0.2289-0.6475-0.3449-1.032-0.3449c-0.3735,0-0.7522,0.1277-1.0222,0.3377l-4.6168,3.4311l0.0033-0.0089  l1.8815-4.9857l0.0341-0.0904l0.0162-0.0953c0.1056-0.6219-0.0991-1.2568-0.5651-1.715L1.4643,7h3.9936  c0.4063,0,1.1528-0.1328,1.5874-1.0221L7.0613,5.945l0.0136-0.034L8.8668,1.442C8.9182,1.3233,8.9618,1.2313,8.998,1.1601   M8.9884-0.0004C8.5395-0.0005,8.2936,0.2503,7.9493,1.0441L6.1468,5.5388C6.0135,5.8116,5.8236,6,5.4579,6H1.2215  c-0.8378,0-1.118,1.0907-0.5749,1.6256l3.3903,3.1789c0.2157,0.2123,0.3141,0.5183,0.2632,0.8182l-1.8815,4.9857  c-0.0533,0.1479-0.1147,0.2774-0.1147,0.4527c0,0.5182,0.4482,0.9383,1.0012,0.9383c0.3491,0,0.5821-0.1845,0.6382-0.2232  l4.6208-3.4344c0.1154-0.0896,0.2794-0.1403,0.4257-0.1403c0.1463,0,0.2848,0.0327,0.4258,0.1403l4.537,3.3639  c0.3628,0.2876,0.6116,0.2939,0.7301,0.2939c0.0053,0,0.0103,0,0.015,0c0.5463-0.0001,0.9892-0.4151,0.9892-0.927  c0-0.202-0.1047-0.4632-0.2367-0.8479l-1.7546-4.602c-0.051-0.2999,0.0474-0.6059,0.2631-0.8182l3.3954-3.1789  C17.8973,7.0907,17.6134,6,16.7794,6h-4.2299c-0.3637,0-0.5923-0.1884-0.7257-0.4612l-1.7949-4.5044  C9.7156,0.211,9.427-0.0004,8.9884-0.0004L8.9884-0.0004z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.5061758086f00c5a79072f5c1d815ccf.svg";
export { ForwardRef as ReactComponent };